jQuery(function () {
  window.Sparkle.preparePatientJourneyTaskModal = function (modalSelector, tool) {
    if (tool == "email") {
      window.Sparkle.prepareSendEmailForm(modalSelector);
    } else if (tool == "text") {
      window.Sparkle.prepareSendTextForm(modalSelector);
    }
  };
});
